import { render, staticRenderFns } from "./MainSteps.vue?vue&type=template&id=18b4533c&scoped=true"
import script from "./MainSteps.vue?vue&type=script&lang=js"
export * from "./MainSteps.vue?vue&type=script&lang=js"
import style0 from "./MainSteps.vue?vue&type=style&index=0&id=18b4533c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b4533c",
  null
  
)

export default component.exports